export const changeFeatureToggleValue = (toggleName, newValue) => ({
  type: "FEATURES_CHANGE",
  payload: { toggleName, newValue }
});

export default {};
